export default defineNuxtRouteMiddleware((to, from) => {
  /*
    manually scroll user to top of the page when layout is switched,
    because it's not working sometimes with dynamic layouts
   */
  if (to.meta.layout !== from.meta.layout) {
    if (process.client) {
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }
})
